import _ from "lodash";
import { ListHeader, ListRow } from "../List";
import { getColumnWidthClassName } from "../table/tableUtils";
import { classNames } from "../utils/classNames";
import { isDefined } from "../utils/isDefined";
import parseChildren from "../utils/parseChildren";
import { COL_PIXEL_MAP } from "../utils/sizing";
export const buildGridColumnWidthToString = (columns) => columns.reduce((gridColumns, column) => gridColumns + " " + COL_PIXEL_MAP.get(column), "");
export const getListCellContentClassNames = (link, tooltip) => classNames("list__cell--text", "list__cell--value", link ? "link" : "", tooltip ? getColumnWidthClassName(tooltip.width) : "");
export const getGridColumns = (gridColumns) => {
    if (gridColumns && typeof gridColumns !== "string") {
        gridColumns = buildGridColumnWidthToString(gridColumns);
    }
    return gridColumns;
};
export const warnIfWidthArrayNotSet = (listChildren) => {
    let warnForRow = false;
    let warnForHeader = false;
    const listRow = listChildren.filterByType(ListRow);
    if (Array.isArray(listRow)) {
        listRow.forEach((item) => {
            if (warnForRow === false && item?.props) {
                const listRowChildren = parseChildren(item?.props?.children);
                const listRowChildRow = listRowChildren.filterByType(ListRow);
                if (listRowChildRow.length > 0) {
                    listRowChildRow.forEach((childItem) => {
                        if (warnForRow === false && childItem?.props) {
                            warnForRow = missingGridColumn(childItem?.props);
                        }
                    });
                }
                else {
                    warnForRow = missingGridColumn(item?.props);
                }
            }
        });
    }
    const listHeader = listChildren.findByType(ListHeader);
    warnForHeader = missingGridColumn(listHeader?.props);
    if (warnForRow || warnForHeader) {
        console.warn(`[piston-ux] If you are using the prop "contained" on List you need to pass GridColumnWidth[] to${warnForRow ? " ListRow" : ""}${warnForRow && warnForHeader ? " and" : ""}${warnForHeader ? " ListHeader" : ""} prop "gridColumns".`);
    }
};
export const missingGridColumn = (props) => {
    if (!props)
        return false;
    if (_.isEmpty(props))
        return false;
    return props?.gridColumns === undefined || !Array.isArray(props.gridColumns);
};
export function getListCellLinkAttributes(listCellLink, hasChidlren) {
    let ListHTMLElement = "span";
    let linkAttributes = {};
    if (listCellLink?.link === undefined) {
        linkAttributes = {
            onClick: listCellLink?.onClick,
            onKeyPress: listCellLink?.onClick,
            "aria-label": listCellLink?.ariaLabel,
            role: hasChidlren
                ? listCellLink?.onClick && listCellLink?.role === undefined
                    ? "link"
                    : listCellLink?.role
                : "none",
            id: listCellLink?.id,
        };
    }
    else {
        if (isDefined(listCellLink?.link?.url)) {
            if (listCellLink?.link?.routerLink) {
                ListHTMLElement = listCellLink?.link?.routerLink;
                linkAttributes = {
                    href: listCellLink?.link.url,
                    to: listCellLink?.link.url,
                };
            }
            else {
                ListHTMLElement = "a";
                linkAttributes = {
                    href: listCellLink?.link?.url,
                    ...(listCellLink.link.newTab
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {}),
                };
            }
        }
    }
    return { ListHTMLElement, linkAttributes };
}
export function getListLinkAttributes(link) {
    let linkAttributes = {};
    if (link?.routerLink) {
        linkAttributes = {
            href: link.url,
            to: link.url,
        };
    }
    else {
        linkAttributes = {
            href: link?.url,
        };
    }
    return linkAttributes;
}
export const getTabIndex = (initialise, index, indexOffset) => {
    if (!initialise) {
        return undefined;
    }
    const columnNumber = index + indexOffset;
    return columnNumber === 1 ? 0 : undefined;
};
